import { grey } from '@mui/material/colors';
import { getComparisonOperatorColor } from 'pages/GatewayRules/utils/getComparisonOperatorColor';
import { Box } from 'shared/mui/Box';
import { Expression, ExpressionParam } from 'types/embedded/gatewayRule';

import { GatewayRuleFieldChip } from './GatewayRuleFieldChip';
import { GatewayRuleFieldExpressionParam } from './GatewayRuleFieldExpressionParam';

type Props = {
  expression: Expression;
};

export function GatewayRuleFieldExpression({ expression }: Props): JSX.Element {
  const isCustomerId = expression.expressionParam?.alias === 'customerId';

  return (
    <Box
      sx={{
        margin: '6px 0',
        padding: '4px',
        boxSizing: 'border-box',
        borderColor: grey[300],
        borderRadius: '4px',
        borderWidth: '1px',
        borderStyle: 'solid',
        backgroundColor: '#fff',
        width: '100%',
        display: 'inline-flex',
        flexWrap: 'wrap',
        rowGap: '4px',
      }}
    >
      <GatewayRuleFieldChip label={expression.expressionParam?.name || ''} />
      <GatewayRuleFieldChip
        label={expression.comparisonOperator?.description || ''}
        sx={
          isCustomerId
            ? {
                '& .MuiChip-label': {
                  color: getComparisonOperatorColor(expression.comparisonOperator),
                },
              }
            : undefined
        }
      />
      <GatewayRuleFieldExpressionParam
        param={expression?.expressionParam || ({} as ExpressionParam)}
        value={(expression?.value as string[]) || []}
      />
    </Box>
  );
}
